import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';

import { useConversationState } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';

import { mapData } from './conversationMembers.utils';

// @TODO extract to common catalog, consider storing the data in conversation provider
export const useConversationMembers = () => {
  const { memberIds } = useConversationState();
  const { personasDict } = usePersonaCollection();

  return useMemo(() => mapData(personasDict, memberIds), [memberIds, personasDict]);
};
